import classnames from 'classnames';
import { unescapeHTML } from 'underscore.string';
import { REGIONS } from 'constants/Regions';
import { convertMetersToMiles } from 'utils/distance';

export const isProd = () => {
  return (
    window.location.href.includes('command.cargomatic.com') ||
    window.location.href.includes('command-thailand.cargomatic.com')
  );
};
export const isAcceptance = () => {
  return window.location.href.includes('command-acceptance.cargomatic.com');
};

export const isStaging = () => {
  return window.location.href.includes('command-staging.cargomatic.com');
};

export const isLocal = () => {
  return window.location.href.includes('localhost');
};

export const isUS = () => {
  return REGION_CODE === REGIONS.US;
};

export const isTest = () => {
  return process?.env?.NODE_ENV === 'test';
};

export const getDateFromObjectId = (id) => {
  const unixTime = parseInt(id.substring(0, 8), 16);
  return new Date(unixTime * 1000);
};

export const fakeMongoObjectId = () => {
  const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  return (
    timestamp +
    'xxxxxxxxxxxxxxxx'
      .replace(/[x]/g, () => {
        return ((Math.random() * 16) | 0).toString(16);
      })
      .toLowerCase()
  );
};

export function isImageFile(ext = '') {
  const fileExt = ext.toLowerCase();

  if (['jpeg', 'png', 'bmp', 'jpg'].includes(fileExt)) {
    return true;
  }
  return false;
}

export const getFileIconClass = (ext = '') => {
  let fileIconClass;

  const fileExt = ext.toLowerCase();

  if (['jpeg', 'png', 'bmp', 'jpg'].includes(fileExt)) {
    fileIconClass = 'fa-image';
  } else if (fileExt === 'doc' || fileExt === 'docx') {
    fileIconClass = 'fa-file-word-o';
  } else if (fileExt === 'xls' || fileExt === 'xlsx') {
    fileIconClass = 'fa-file-excel-o';
  } else if (fileExt === 'pdf') {
    fileIconClass = 'fa-file-pdf-o';
  } else if (['eml', 'msg'].includes(fileExt)) {
    fileIconClass = 'fa-envelope-o';
  } else {
    fileIconClass = 'fa-file-o';
  }
  return classnames({
    fa: true,
    [fileIconClass]: true,
  });
};

export const metersToMiles = (meters) => {
  return meters && meters > 0 ? convertMetersToMiles(meters) : 0;
};

export const unescapeAmpersand = (text) => {
  return text && typeof text === 'string' ? text.replace(/&amp;/gi, '&') : text;
};

export const unescapeSpecialChars = (text) => {
  return text && typeof text === 'string' ? unescapeHTML(text) : text;
};

export const getFileExtensionFromUrl = (url) => {
  const extensionRegex = /\.(\w{3,4})(?:$|\?)/;
  const match = extensionRegex.exec(url);

  return match ? match[1] : null;
};

export function getFileExtension(filename = '') {
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}
